import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IConvo } from '../../../model/convo'
import { IStatement } from '../../../model/statement'
import statementStore from '../../statement/statement-store'
import fetchAllJybed from './fetch-all-jybed'
import statementUtils from '../../statement/actions/statement-utils'

export default async function considerStatement(context: BareActionContext<ConvoState, RootState>, payload: { statement: IStatement, convo: IConvo })
{
  statementUtils.statementService.consider(payload.statement).then((result: any) => {
    statementStore.dispatchFetchReactions(payload.statement)
    fetchAllJybed(context, payload.convo)
    return
  })
}
